import pBoxIcon from '../../assets/icons/p_box_v2.png';
import { useContext } from 'react';
import { useNavigate } from 'react-router';
import useSWR from 'swr';
import { AuthContext } from '../../context/AuthContext';
import { getGetMainMarkItemListUrl } from '../../api/generated/time-nyang/main/main.ts';
import NPayIcon from '../../assets/icons/badge_npay.svg';

function PlaygroundPointCard({ point = 0 }) {
  const navigate = useNavigate();
  const { API_SERVER_DOMAIN, useAccessToken, fetchWithToken } = useContext(AuthContext);
  const accessToken = useAccessToken();
  const { data: mainMarkInfo } = useSWR(
    accessToken && [`${API_SERVER_DOMAIN}${getGetMainMarkItemListUrl()}`, accessToken],
    fetchWithToken,
  );

  const displayPoint = Number.isFinite(point) ? point : 0;
  const mainMarkItems = Array.isArray(mainMarkInfo?.mainMarkItems)
    ? mainMarkInfo.mainMarkItems
        .filter((item) => Number.isFinite(item?.goodsPrice))
        .sort((a, b) => (a?.goodsPrice ?? 0) - (b?.goodsPrice ?? 0))
    : [];
  const selectedMarkTarget =
    mainMarkItems.find((item) => displayPoint <= (item?.goodsPrice ?? Number.MAX_SAFE_INTEGER)) ??
    mainMarkItems[mainMarkItems.length - 1];
  const targetPoint = Math.max(1, Number(selectedMarkTarget?.goodsPrice ?? 1));
  const progressRatio = Math.max(0, Math.min(displayPoint / targetPoint, 1));
  const progressPercent = progressRatio * 100;
  const markLabel =
    selectedMarkTarget?.goodsName || selectedMarkTarget?.goodsGoodsName || '2천원권';

  return (
    <div className="pdm-point relative flex h-full w-full flex-col items-center px-2.5 pt-[3.5rem]">
      <div className="mt-2 flex flex-col items-center">
        <button
          type="button"
          className="border-0 bg-transparent outline-none"
          onClick={() => navigate('/user/points')}
          aria-label="내 포인트 보기"
        >
          <img src={pBoxIcon} alt="" className="h-[13rem] w-auto object-contain" />
        </button>

        <button
          type="button"
          className="relative inline-flex cursor-pointer items-baseline justify-center gap-1 overflow-hidden rounded-2xl border-0 bg-gradient-to-b from-[#3B5CD2] to-[#8B68DD] px-[25px] py-3 shadow-[0px_8px_20px_0px_#4B5BC1] outline-none -mt-3"
          onClick={() => navigate('/user/points')}
          aria-label={`내 포인트 ${displayPoint.toLocaleString()}P`}
        >
          <span className="relative z-10 text-center font-['Nunito'] text-xl font-extrabold leading-none text-white">
            {displayPoint.toLocaleString()}
          </span>
          <span className="relative z-10 text-center font-['Pretendard'] text-[15px] font-bold leading-none text-white">
            P
          </span>
          {/* Figma 1890:10308 — 대각 하이라이트 (고정 폭이 아니라 버튼 전체) */}
          <span
            className="pointer-events-none absolute inset-x-0 -top-[0.67px] bottom-[0.67px] rounded-[30px]"
            style={{
              backgroundImage:
                'linear-gradient(97.23deg, rgba(255,255,255,0) 30%, rgba(255,255,255,0.35) 50%, rgba(255,255,255,0) 70%)',
            }}
            aria-hidden="true"
          />
        </button>
      </div>

      {/* 만보기 레일과 같은 위치·높이의 글래스 바 */}
      <div className="pdm-glass pdm-point-bar">
        <div className="mx-auto flex w-[93%] flex-col items-center gap-1.5">
          <div className="relative h-2 w-full rounded bg-black/20">
            <div
              className="absolute left-0 top-0 h-2 rounded bg-[#3B5CD2]"
              style={{ width: `${progressPercent}%` }}
            />
            <span
              className="absolute top-1/2 size-[18px] -translate-x-1/2 -translate-y-1/2 rounded-[9px] border-[3px] border-white bg-[#3B5CD2] shadow-[0px_2px_6px_rgba(0,0,0,0.18)]"
              style={{ left: `${Math.max(3, Math.min(progressPercent, 97))}%` }}
              aria-hidden="true"
            />
          </div>

          <div className="flex items-center gap-4">
            <div className="flex items-center gap-[5px]">
              <button
                type="button"
                className="border-0 bg-transparent p-0 outline-none"
                onClick={() => navigate('/coupons', { state: { selectedBrand: '네이버페이' } })}
                aria-label="네이버페이 상품 보기"
              >
                <img src={NPayIcon} alt="n_pay" className="h-[17px] w-[45px] object-contain" />
              </button>
              <span className="whitespace-nowrap font-['Pretendard'] text-xs font-semibold tracking-[-0.5px] text-white">
                상품권 까지 ({markLabel})
              </span>
            </div>
            <span className="h-[9px] w-px bg-white/50" aria-hidden="true" />
            <div className="whitespace-nowrap font-['Pretendard'] text-xs font-extrabold tracking-[0.06px]">
              <span className="text-white">{displayPoint.toLocaleString()}</span>
              <span className="text-[#3B5CD2]"> / {targetPoint.toLocaleString()}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PlaygroundPointCard;
